import { Cache } from "memory-cache";
import { Client } from "../service/esiclient";
import { StructureEntity } from ".";
import { fetchAllCharacters, fetchCharacterTokenFromID, fetchFirstCharacterID } from "../helpers/tokenhelper";
import { getErrorCount, setErrorcount, updateErrorCount } from "../helpers/ErrorCache";

// ESI Client
const esiClient = new Client();

// Cache
const cache = new Cache();

export async function getCachedStructureEntity(
  structure_id: number,
  character_id: number
): Promise<StructureEntity | null> {
  const charList = fetchAllCharacters();
  if (character_id === null || !charList.length || structure_id < 1000000000000) {
    return null;
  } else if (character_id === 1) {
    const firstCharID = await fetchFirstCharacterID();
    if (firstCharID == 1) return null;
    character_id = firstCharID;
  }
  const accesstoken = await fetchCharacterTokenFromID(character_id);
  let entity: any = await cache.get("structure-" + character_id.toString() + "-" + structure_id.toString());
  if (entity) {
    if (entity._dataTypeName == "Structure") {
      return entity;
    } else {
      return null;
    }
  }
  const publicStructure = await getCachedPublicStructures();
  if (accesstoken.success) {
    try {
      if (publicStructure !== null && publicStructure.indexOf(structure_id) !== -1) {
        //We know it's a public structure so it's safe'ish to call
        const data = await esiClient.get_universe_structures_structure_id(null, null, structure_id, accesstoken.token);
        updateErrorCount(data.headers["x-esi-error-limit-remain"], data.headers["x-esi-error-limit-reset"]);
        entity = new StructureEntity(structure_id, data.result);
        cache.put(
          "structure-" + character_id.toString() + "-" + structure_id.toString(),
          entity,
          60 * 60 * 1000 /* 1 hour */
        );
        return entity;
      } else {
        //It's not a public structure
        const errorCount = getErrorCount();
        if (parseInt(errorCount.toString()) > 10) {
          const data = await esiClient.get_universe_structures_structure_id(
            null,
            null,
            structure_id,
            accesstoken.token
          );
          updateErrorCount(data.headers["x-esi-error-limit-remain"], data.headers["x-esi-error-limit-reset"]);
          entity = new StructureEntity(structure_id, data.result);
          cache.put(
            "structure-" + character_id.toString() + "-" + structure_id.toString(),
            entity,
            60 * 60 * 1000 /* 1 hour */
          );
          return entity;
        } else {
          //we've hit our errorlimit~ so we dont cache it incase the user submits again when the errors would let them
          return null;
        }
      }
    } catch (error) {
      //when we hit an error we have no idea the limit or the expiry, so we're limited to just lowering w/e was before and updating the reset to 1 minute
      setErrorcount(1);
      //console.error(error);
      cache.put(
        "structure-" + character_id.toString() + "-" + structure_id.toString(),
        [],
        60 * 60 * 1000 /* 1 hour */
      );
      return null;
    }
  } else {
    return null;
  }
}

export async function getCachedPublicStructures(): Promise<number[] | null> {
  let list: any = await cache.get("publicstructures");
  if (list) {
    return list;
  }
  try {
    const listdata = await esiClient.get_universe_structures(null, null, null);
    if (listdata !== null) {
      cache.put("publicstructures", listdata, 60 * 60 * 1000);
      return listdata;
    } else {
      return [];
    }
  } catch {
    return null;
  }
}
